"use strict";

angular.module("vendor")
.service("ProductSequenceService", function($resource, FlashBag, appConfig) {
    var productSequenceResource = $resource(
        appConfig.API_SERVER + "/catalog/vendor/products/sequences/:id/", {
            id: "@id"
        }, {
            get: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            },
            query: {
                method: "GET",
                isArray: true,
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            },
            save: {
                method: "POST"
            },
            update: {
                method: "PUT"
            },
            delete: {
                method: "DELETE",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });
    this.query = function() {
        return productSequenceResource.query();
    };
    this.get = function(id) {
        var params = {
            id: id
        };
        return productSequenceResource.get(params);
    };
    this.save = function(data) {
        if (data.id) {
            return data.$update();
        }
        else {
            var catalog = new productSequenceResource(data);
            return catalog.$save();
        }
    };
    this.patch = function(data) {
        var catalog = new productSequenceResource(data);
        return catalog.$patch();
    };
    this.delete = function(id) {
        var params = {
            id: id
        };
        return productSequenceResource.delete(params);
    };
    this.setPickingOrder = function(id) {
        var pickingOrderResource = $resource(
            appConfig.API_SERVER + "/catalog/vendor/products/sequences/picking-order/", {}, {
                save: {
                    method: "POST",
                    interceptor: {responseError: FlashBag.responseErrorInterceptor}
                }
            });
        var params = {};
        if (id) {
          params.sequence_id = id;
        }
        return pickingOrderResource.save(params);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/product-sequence/product-sequence.service.js
// module id = 806
// module chunks = 0